'use strict';
module.exports = require('./lib/index');



//////////////////
// WEBPACK FOOTER
// ./~/shortid/index.js
// module id = 465
// module chunks = 5 7 8 9 10 11 13 22 23 24 25 29 57 58